export default __webpack_public_path__ + "fdb191bdf781b12ad471b45ac96704ce.ttf";